<div class="grid grid-col-1 xl:grid-cols-7 h-screen overflow-y-auto">
  <div
    class="absolute inset-0 bg-gradient-to-t from-[#1A2366] from-0% to-70% to-transparent top-[85%] w-full left-1/2 -translate-x-1/2 xl:hidden"></div>

  <div
    class="col-span-1 xl:col-span-4 flex items-center justify-center relative">
    <div
      class="flex flex-col gap-10 md:flex-1 h-full py-8 md:p-24 w-[90vw] max-w-2xl">
      @if (isInvite) {
        <v-public-logo-header
          [header]="
            'pages.register.inviteHeader'
              | transloco: { organizationName: invitation?.organization?.name }
          "
          [subheader]="
            'pages.register.inviteSubheader' | transloco
          "></v-public-logo-header>
      } @else {
        <v-public-logo-header
          [header]="'pages.register.header' | transloco"
          [subheader]="
            'pages.register.subheader' | transloco
          "></v-public-logo-header>
      }

      <v-card padding="lg" variant="glass-v2">
        <div slot="body">
          <app-kratos-form-v2
            #kf
            [flow]="registrationFlow()"
            [busy]="isCompletingRegistrationFlow()"
            (submitFlow)="submitFlow($event)"
            [renderFallback]="false">
            @if (kf.hasMessages()) {
              <ng-template vKfName="messages"></ng-template>
            }

            <div class="flex flex-col gap-4">
              @if (kf.hasOidcProviders()) {
                <!-- two columns; an odd last provider spans the full row -->
                <div class="grid grid-cols-2 gap-4 *:last:odd:col-span-2">
                  @if (kf.isVisible('oidc-input-provider-google')) {
                    <div>
                      <ng-template
                        [vKfName]="'oidc-input-provider-google'"></ng-template>
                    </div>
                  }
                  @if (kf.isVisible('oidc-input-provider-microsoft')) {
                    <div>
                      <ng-template
                        [vKfName]="'oidc-input-provider-microsoft'"></ng-template>
                    </div>
                  }
                  @if (kf.isVisible('oidc-input-provider-github')) {
                    <div>
                      <ng-template
                        [vKfName]="'oidc-input-provider-github'"></ng-template>
                    </div>
                  }
                  @if (kf.isVisible('oidc-input-provider-apple')) {
                    <div>
                      <ng-template
                        [vKfName]="'oidc-input-provider-apple'"></ng-template>
                    </div>
                  }
                </div>

                <div class="flex items-center gap-4 my-4">
                  <div class="h-px bg-surface-3 flex-1"></div>
                  <span class="text-subtle text-sm">OR</span>
                  <div class="h-px bg-surface-3 flex-1"></div>
                </div>
              }

              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div class="col-span-1">
                  <ng-template
                    [vKfName]="
                      'password-input-traits-name-first'
                    "></ng-template>
                </div>
                <div class="col-span-1">
                  <ng-template
                    [vKfName]="'password-input-traits-name-last'"></ng-template>
                </div>
              </div>

              <div class="col-span-1">
                <ng-template
                  [vKfName]="'password-input-traits-email'"></ng-template>
              </div>
              <div class="col-span-1">
                <ng-template
                  [vKfName]="'password-input-password'"></ng-template>
              </div>
              <div class="col-span-1 mt-2">
                <ng-template
                  [vKfName]="'password-input-method-password'"></ng-template>
              </div>
            </div>
          </app-kratos-form-v2>
        </div>
      </v-card>
      <div class="text-center text-subtle">
        {{ 'pages.register.loginHint' | transloco }}
        <a routerLink="/login" class="text-primary font-bold">{{
          'pages.register.login' | transloco
        }}</a>
      </div>
    </div>
  </div>
  <div class="hidden xl:col-span-3 xl:flex p-10 h-full">
    <div
      class="flex-1 rounded-[3rem] from-surface to-transparent bg-linear-to-b overflow-hidden relative">
      <div
        class="absolute w-full h-full bg-radial-[at_50%_50%] to-indigo-500 via-indigo-600 via-75% from-30% from-surface to-90% mask-b-from-00% mask-b-to-50%"></div>

      <div
        class="flex flex-col h-full justify-around p-20 pt-60 relative gap-8">
        <div
          class="flex items-center justify-center text-center flex-col gap-4">
          <h2
            class="text-3xl font-medium text-white"
            [innerHTML]="'pages.register.convince.header' | transloco"></h2>
          <p
            class="text-base leading-6 text-subtle"
            [innerHTML]="'pages.register.convince.subheader' | transloco"></p>
        </div>
        <div class="text-center mt-6">
          <span class="text-subtle text-sm">
            {{ 'pages.register.convince.logoSection.header' | transloco }}
          </span>
          <div
            class="mask-x-from-50% mask-x-to-100% overflow-hidden pb-14 pt-4">
            <div class="flex min-w-max whitespace-nowrap animate-marquee items-center">
              <!-- first set -->
              <img
                src="./assets/images/logos/trusted/edudip.svg"
                alt="Edudip Logo"
                class="mx-10 h-8 pointer-events-none flex-shrink-0 select-none" />
              <img
                src="./assets/images/logos/trusted/spacion.svg"
                alt="Spacion Logo"
                class="mx-10 h-5 pointer-events-none flex-shrink-0 select-none" />
              <img
                src="./assets/images/logos/trusted/sh-tech-ventures.svg"
                alt="SH Tech Ventures Logo"
                class="mx-10 h-5 pointer-events-none flex-shrink-0 select-none" />
              <img
                src="./assets/images/logos/trusted/hyperspace.svg"
                alt="Hyperspace Logo"
                class="mx-10 h-3 pointer-events-none flex-shrink-0 select-none" />

              <!-- duplicate set -->
              <img
                src="./assets/images/logos/trusted/edudip.svg"
                alt="Edudip Logo"
                class="mx-10 h-8 pointer-events-none flex-shrink-0 select-none" />
              <img
                src="./assets/images/logos/trusted/spacion.svg"
                alt="Spacion Logo"
                class="mx-10 h-5 pointer-events-none flex-shrink-0 select-none" />
              <img
                src="./assets/images/logos/trusted/sh-tech-ventures.svg"
                alt="SH Tech Ventures Logo"
                class="mx-10 h-5 pointer-events-none flex-shrink-0 select-none" />
              <img
                src="./assets/images/logos/trusted/hyperspace.svg"
                alt="Hyperspace Logo"
                class="mx-10 h-3 pointer-events-none flex-shrink-0 select-none" />
            </div>
          </div>
          <div class="flex justify-center">
            <div class="p-8 rounded-2xl bg-surface max-w-lg">
              <div class="flex gap-4 items-center">
                <div class="bg-gray-400 h-12 w-12 rounded-full">
                  <img
                    src="./assets/images/logos/trusted/testimonial-avatar.png"
                    [alt]="
                      'pages.register.convince.testimonial.name' | transloco
                    "
                    class="h-12 w-12 brightness-80 rounded-full pointer-events-none select-none" />
                </div>
                <div class="flex flex-col leading-4 text-start">
                  <span class="text-lg font-medium">{{
                    'pages.register.convince.testimonial.name' | transloco
                  }}</span>
                  <span class="text-subtle text-sm">{{
                    'pages.register.convince.testimonial.role' | transloco
                  }}</span>
                </div>
              </div>
              <p
                class="text-primary mt-6 text-start"
                [innerHTML]="
                  'pages.register.convince.testimonial.testimonial' | transloco
                "></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
